import { useCallback } from 'react'
import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { useSnackbar } from 'notistack'
import { useDeleteShiftTemplateMutation } from '@/core/services/planning'
import { getApiErrorMessage } from '@/utils/errors'

export function useDeleteShiftTemplate() {
  useLingui()
  const { enqueueSnackbar } = useSnackbar()

  const [deleteShiftTemplateMutation, { isLoading }] = useDeleteShiftTemplateMutation()

  const deleteShiftTemplate = useCallback(async (planningId: string, shiftTemplateId: string) => {
    try {
      await deleteShiftTemplateMutation({ planningId, shiftTemplateId }).unwrap()
      enqueueSnackbar(t`Shifts have been deleted successfully`, { variant: 'success' })
    } catch (error) {
      enqueueSnackbar(getApiErrorMessage(error), { variant: 'error' })
    }
  }, [])

  return [deleteShiftTemplate, isLoading] as const
}
